module.exports = __webpack_public_path__ + "static/media/img3_1.3201a18f.png";